import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

import { CreateTrainService } from "../../../../thematics/create-train.service";
import { Dynamic, DynamicType } from "../../../../thematics/models/dynamic.model";
import { Thematic } from "../../../../thematics/models/thematic.model";
import { TrainRepository } from "../../../../trains/repositories/train.repository";
import { CreditCheckService } from "../../../services/credit-check.service";

@Component({
  selector: 'app-dynamics',
  templateUrl: './dynamics.component.html',
  styleUrls: [ './dynamics.component.scss' ]
})
export class DynamicsComponent implements OnDestroy {
  @Input() thematic?: Thematic;

  @Input() dynamics?: Dynamic[];

  @Input() canValidate = false;

  @Input() goToAvailableTrains = false;

  destroy$ = new Subject<void>();

  constructor(
    private readonly trainRepository: TrainRepository,
    private readonly router: Router,
    private readonly createTrainService: CreateTrainService,
    private readonly creditCheckService: CreditCheckService,
  ) {
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  getDynamics(): Dynamic[] {
    return (this.dynamics ?? this.thematic?.dynamics?.filter(dynamic => dynamic.isEnabled) ?? [])
    .sort((a, b) => {
      if (a.type === DynamicType.SPEECH && b.type === DynamicType.COACHING) return -1;
      if (a.type === DynamicType.COACHING && b.type === DynamicType.SPEECH) return 1;
      return 0;
    });  
}

  chooseDynamic(type: DynamicType): void {
    const dynamic = this.getDynamics()?.find(d => d.type === type);
    const { thematic } = this;
    if (dynamic && thematic) {
      // FIX ME: redundance ?
      (window._mtm || []).push({ 'event': 'creation-parcours', 'nom-parcours': thematic.title });
      (window._mtm || []).push({ 'event': 'nouvel-horaire-parcours', 'nom-parcours': thematic.title });
      
      this.creditCheckService.checkAndNotify(
        dynamic.type,
        () => {
          this.trainRepository.getAvailableTrains().pipe(takeUntil(this.destroy$))
            .subscribe(trains => {
              this.createTrainService.selectDynamic(
                dynamic, 
                thematic, 
                this.goToAvailableTrains && !!trains.filter(t => t.dynamic.id === dynamic?.id).length
              );
            });
        }
      );
    }
  }

  parseDynamic = (dynamic: Dynamic) => ({
    title: dynamic.dynamicType,
    bulletPoints: dynamic.description.split('\n')
  });

  goToDynamicDistinction() {
    // this.tracker.trackEvent(TrackerCategory.THEMATIC_PAGE_TALKER, TrackerAction.CLICK, 'learnmoreLink');
    this.router.navigate(['dynamics-distinction']);
  }
}
